/* Razab custom page sections — scroll reveal, policy selector, material explorer.
   Safe to load on every page: everything is opt-in through data attributes. */
(function () {
  if (window.__razabPagesInit) return;
  window.__razabPagesInit = true;

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('.razab-reveal:not(.is-visible)');
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var delay = parseInt(entry.target.getAttribute('data-razab-delay') || '0', 10);
          window.setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, delay);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initPolicySelect(root) {
    (root || document)
      .querySelectorAll('[data-razab-policy-select]')
      .forEach(function (select) {
        if (select.dataset.razabBound) return;
        select.dataset.razabBound = 'true';
        select.addEventListener('change', function () {
          if (select.value) window.location.href = select.value;
        });
      });
  }

  function initExplorer(root) {
    (root || document).querySelectorAll('[data-razab-explorer]').forEach(function (stage) {
      if (stage.dataset.razabBound) return;
      stage.dataset.razabBound = 'true';

      var buttons = stage.querySelectorAll('[data-razab-hotspot]');
      var panels = stage.querySelectorAll('[data-razab-detail]');

      function activate(id) {
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-razab-hotspot') === id));
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-razab-detail') !== id;
        });
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          activate(button.getAttribute('data-razab-hotspot'));
        });
      });

      if (buttons.length) activate(buttons[0].getAttribute('data-razab-hotspot'));
    });
  }

  function initAll(root) {
    initReveal(root);
    initPolicySelect(root);
    initExplorer(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Shopify theme editor: re-run when a section is added or re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
